import { UserIsAuthenticated, UserHasValidPassword } from 'containers/authContainers'
import StudiesContainer from './containers/StudiesContainer'

export default store => {
  return {
    getComponent(nextState, cb) {
      require.ensure([], async () => {
        cb(null, UserIsAuthenticated(UserHasValidPassword(StudiesContainer)), 'studies')
      })
    },
  }
}
